/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminRoadmapJiraGroupMappingResponse } from '../models/AdminRoadmapJiraGroupMappingResponse';
import type { AdminRoadmapJiraGroupMappingsResponse } from '../models/AdminRoadmapJiraGroupMappingsResponse';
import type { AdminRoadmapJiraGroupMappingUpdate } from '../models/AdminRoadmapJiraGroupMappingUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminRoadmapJiraGroupMappingsService {

    /**
     * List Jira Group Mappings
     * @returns AdminRoadmapJiraGroupMappingsResponse Successful Response
     * @throws ApiError
     */
    public static listJiraGroupMappingsApiV1AdminRoadmapJiraGroupMappingsGet(): CancelablePromise<AdminRoadmapJiraGroupMappingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/roadmap/jira-group-mappings',
        });
    }

    /**
     * Upsert Jira Group Mapping
     * @param jiraFieldId
     * @param jiraOptionId
     * @param requestBody
     * @returns AdminRoadmapJiraGroupMappingResponse Successful Response
     * @throws ApiError
     */
    public static upsertJiraGroupMappingApiV1AdminRoadmapJiraGroupMappingsJiraFieldIdJiraOptionIdPut(
        jiraFieldId: string,
        jiraOptionId: string,
        requestBody: AdminRoadmapJiraGroupMappingUpdate,
    ): CancelablePromise<AdminRoadmapJiraGroupMappingResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/roadmap/jira-group-mappings/{jira_field_id}/{jira_option_id}',
            path: {
                'jira_field_id': jiraFieldId,
                'jira_option_id': jiraOptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Jira Group Mapping
     * @param jiraFieldId
     * @param jiraOptionId
     * @returns void
     * @throws ApiError
     */
    public static deleteJiraGroupMappingApiV1AdminRoadmapJiraGroupMappingsJiraFieldIdJiraOptionIdDelete(
        jiraFieldId: string,
        jiraOptionId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/roadmap/jira-group-mappings/{jira_field_id}/{jira_option_id}',
            path: {
                'jira_field_id': jiraFieldId,
                'jira_option_id': jiraOptionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
